/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ParticipantKind = {
    None: 'NONE',
    User: 'USER',
    Client: 'CLIENT',
    Shared: 'SHARED',
    Workflow: 'WORKFLOW'
} as const;
export type ParticipantKind = typeof ParticipantKind[keyof typeof ParticipantKind];


export function instanceOfParticipantKind(value: any): boolean {
    for (const key in ParticipantKind) {
        if (Object.prototype.hasOwnProperty.call(ParticipantKind, key)) {
            if (ParticipantKind[key as keyof typeof ParticipantKind] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ParticipantKindFromJSON(json: any): ParticipantKind {
    return ParticipantKindFromJSONTyped(json, false);
}

export function ParticipantKindFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParticipantKind {
    return json as ParticipantKind;
}

export function ParticipantKindToJSON(value?: ParticipantKind | null): any {
    return value as any;
}

export function ParticipantKindToJSONTyped(value: any, ignoreDiscriminator: boolean): ParticipantKind {
    return value as ParticipantKind;
}

